import { render } from "./servicesListTeaser.vue?vue&type=template&id=7dde2b38"
import script from "./servicesListTeaser.vue?vue&type=script&lang=js"
export * from "./servicesListTeaser.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__